import { fetchAuthSession } from 'aws-amplify/auth';

export class CredentialManager {
  private region: string;

  constructor() {
    this.region = 'us-east-1';
  }

  async getCredentials() {
    try {
      // Get current session with credentials
      const session = await fetchAuthSession({ forceRefresh: false });
      
      if (!session.credentials) {
        throw new Error('No credentials available');
      }
      
      return {
        accessKeyId: session.credentials.accessKeyId,
        secretAccessKey: session.credentials.secretAccessKey,
        sessionToken: session.credentials.sessionToken,
        expiration: session.credentials.expiration?.toISOString() || '',
        region: this.region
      };
    } catch (error) {
      console.error('Failed to get AWS credentials:', error);
      throw error;
    }
  }
}